// @hack: Temporary fix when copying to/from assets/folders with very long names
export const truncateName = (name = '', maxLength = 20) =>
  name.length > maxLength ? `${name.substring(0, maxLength)}…` : name;
